/**
 * Manages locale used by Airship messaging.
 */
export class AirshipLocale {
    constructor(plugin) {
        this.plugin = plugin;
    }
    /**
     * Sets the locale override.
     * @param localeIdentifier The locale identifier.
     * @returns A promise.
     */
    setLocaleOverride(localeIdentifier) {
        return this.plugin.perform('locale#setLocaleOverride', localeIdentifier);
    }
    /**
     * Clears the locale override.
     * @returns A promise.
     */
    clearLocaleOverride() {
        return this.plugin.perform('locale#clearLocaleOverride');
    }
    /**
     * Gets the current locale.
     * @returns A promise with the result.
     */
    getLocale() {
        return this.plugin.perform('locale#getLocale');
    }
}
//# sourceMappingURL=AirshipLocale.js.map